<template>
    <div
        id="IN_MatchCard_Btn_MoreBets"
        class="more_bets"
        v-bind:class="{ _two_columns: !isSoccer(info.sportType), _live: info.isLive, _multiple: isMixParlayMode }"
        v-on:click="goToMatchDetail()"
    >
        <div v-if="info.marketTypeCount.length">
            {{ i18n.t('oddsDisplay_matchFunction_moreBets') }}
            <SvgIcon class="svgIcon" iconName="systemIcon_arrowRight" />
        </div>
    </div>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import type { PropType } from 'vue';
    import { defineComponent } from 'vue';
    import { useRouter } from 'vue-router';
    import type { RouteLocationRaw } from 'vue-router';
    import type { IMatch } from '@/interface/IMatch';
    import { RoutePage, SportType } from '@/interface/enum';
    import { isSoccer } from '@/libraries/helpers/sportsHelper';
    import { getTranslated } from '@/libraries/helpers/translationHelper';
    import { i18n } from '@/libraries/i18n';
    import { useRootStore } from '@/stores/rootStore';
    import SvgIcon from '@/svg/SvgIcon.vue';

    export default defineComponent({
        name: 'MoreBets',
        components: {
            SvgIcon,
        },
        props: {
            info: {
                type: Object as PropType<IMatch>,
                required: true,
            },
        },
        setup(props) {
            const { isMixParlayMode } = storeToRefs(useRootStore());

            const router = useRouter();

            const getMatchDetailRoute = (): RouteLocationRaw => {
                const route = {
                    name: RoutePage.MatchDetail,
                    params: {
                        sportType: SportType.toRouteName(props.info.sportType) ?? '',
                        leagueName: getTranslated(props.info.tournament?.tournamentName).replace(/ /g, '-') ?? '',
                        matchName: `${getTranslated(props.info.homeTeam?.teamName).replace(/ /g, '-')}-vs-${getTranslated(props.info.awayTeam?.teamName).replace(/ /g, '-')}`,
                        matchId: props.info.eventId.toString() ?? '0',
                    },
                };

                return route;
            };

            function goToMatchDetail() {
                if (props.info.marketTypeCount.length) {
                    const route = getMatchDetailRoute();
                    router.push(route);
                }
            }

            return {
                i18n,
                isMixParlayMode,
                isSoccer,
                goToMatchDetail,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/indiaSite/components/match/morebets";
</style>
